import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  isAuthenticated
} from './services/redux/authentication/actions';

class MainStateProvider extends Component {
  componentWillMount() {
    this.props.isAuthenticated();
  }
  render = () => <div>{this.props.children}</div>;
}

const mapStateToProps = state => ({
  user: state.authentication.user
});

const mapDispatchToProps = dispatch => 
  bindActionCreators({
    isAuthenticated
  }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainStateProvider);




// WEBPACK FOOTER //
// ./src/MainStateProvider.js